var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLayout = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "21px",
  height: "21px",
  viewBox: "0 0 21 21",
  xmlns: "http://www.w3.org/2000/svg",
  className: "react-svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1,2.99742191 C1,1.89427625 1.89092539,1 2.99742191,1 L18.0025781,1 C19.1057238,1 20,1.89092539 20,2.99742191 L20,18.0025781 C20,19.1057238 19.1090746,20 18.0025781,20 L2.99742191,20 C1.89427625,20 1,19.1090746 1,18.0025781 L1,2.99742191 Z M4,4 L4,17 L17,17 L17,4 L4,4 Z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 12,
  y: 11,
  width: 3,
  height: 4
}), /*#__PURE__*/React.createElement("rect", {
  x: 6,
  y: 11,
  width: 5,
  height: 4
}), /*#__PURE__*/React.createElement("rect", {
  x: 6,
  y: 6,
  width: 9,
  height: 4
})))));
export default SvgLayout;